import { SpendAccount } from "src/shared/models/spendaccount.model";

export const SpendAccountSerializer = {
  fromJson(json: any): SpendAccount {
    return new SpendAccount(json);
  },

  fromJsonList(json: any[]): SpendAccount[] {
    return json.map((item) => new SpendAccount(item));
  },
};
